'use client'
import Pagination2 from '../common/Pagination2'
import { blogs14, categories } from '@/data/blogs'
import Link from 'next/link'
import Image from 'next/image'
import { useEffect, useState } from 'react'
import Styles from '@/components/blogs/Blog.module.css'

export default function Blog3({ blog }) {
  const addViewNum = async (id) => {
    try {
      const response = await fetch(`/api/blogs/add_Article_Views`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ ArticleID: id }),
      })
      const json = await response.json()
      if (json?.Error) {
        toast.error(`更新瀏覽次數失敗：${json.Error}`)
        return
      }
    } catch (err) {
      console.error('toggleWishlist error:', err)
      toast.error('更新瀏覽次數失敗')
    }
  }

  return (
    <>
      <section className="blog-page container pt-1">
        <div className="blog-list mt-5">
          {blog && blog.ArticleData.length > 0 ? (
            blog.ArticleData.map((elm, i) => (
              <div key={i} className="blog-list__item">
                <div className="blog-list__item-image">
                  <Image
                    loading="lazy"
                    className="h-auto"
                    src={elm.PicturePath}
                    width="680"
                    height="493"
                    alt="image"
                  />
                </div>
                <div className="blog-list__item-detail">
                  <div className="blog-list__item-title">
                    <Link
                      href={`/blogs-list/${elm.ArticleSlug}/${elm.ArticleID}`}
                    >
                      {elm.ArticleTitle}
                    </Link>
                  </div>
                  <div className="blog-list__item-content">
                    <p>{elm.Description}</p>
                  </div>
                  <div className="blog-list__item-meta">
                    <span className="blog-list__item-meta__date">
                      更新日期: {elm.PublishedDateFormatted}
                    </span>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <div className="blog-list__item d-flex justify-content-center">
              <div className="blog-list__item-content">
                <span style={{ fontSize: '24px' }}>該分類沒有資料</span>
              </div>
            </div>
          )}
        </div>
      </section>{' '}
    </>
  )
}
